import logo1 from "../../assets/img/historicEvents/LogoOnlysPPV/GBOF.png";

export const greatBallsOfFireDetail = {
  "great-balls-of-fire": {
    id: "great-balls-of-fire",
    title: "Great Balls of Fire",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "great-balls-of-fire",
        items: [
          {
            id: "great-balls-of-fire-1",
            title: "Great Balls of Fire",
            description: "2017",
            imgUrl: logo1,
          },
        ],
      },
    ],
  },
};
